"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Extended = function Extended(_ref) {
  var centerOptions = _ref.centerOptions,
    filterOptions = _ref.filterOptions,
    activeFilter = _ref.activeFilter,
    updateActiveFilter = _ref.updateActiveFilter,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('tabs--options', 'extended', 'd8-u-relative', 'flex', 'flex-wrap', 'justify-between@md', centerOptions && 'text-center'),
    style: {
      zIndex: 'var(--zindex-header)'
    }
  }, filterOptions && filterOptions.map(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: JSON.stringify(option),
      className: "flex-1"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      text: option.text,
      buttonType: _constants.BUTTON_TYPES.FILTER_EXTENDED,
      onClick: function onClick() {
        return updateActiveFilter(i);
      },
      active: activeFilter === i
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _classnames["default"])(activeFilter === i && 'd8-u-text-bold', 'margin-top-xs', 'display@md', activeFilter !== i && 'd8-u-color-contrast-medium d8-u-text-semi-bold')
    }, typeof filterOptions[i].extendedText === 'string' ? filterOptions[i].extendedText : filterOptions[i].extendedText()));
  })), filterOptions && filterOptions[activeFilter] && filterOptions[activeFilter].extendedText && /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-text-bold margin-top-xs hide@md"
  }, typeof filterOptions[activeFilter].extendedText === 'string' ? filterOptions[activeFilter].extendedText : filterOptions[activeFilter].extendedText()), children && /*#__PURE__*/_react["default"].createElement("div", {
    className: "tabs--content"
  }, children({
    activeFilter: activeFilter
  })));
};
Extended.propTypes = {
  children: _propTypes["default"].any.isRequired,
  filterOptions: _propTypes["default"].array.isRequired,
  centerOptions: _propTypes["default"].bool,
  activeFilter: _propTypes["default"].number,
  updateActiveFilter: _propTypes["default"].func
};
var _default = exports["default"] = Extended;